import { Banner, LoadingWand } from '@ordr-as/umami-react'
import { formatDateAndTime } from '../../../utils/stringUtils'
import { useState } from 'react'
import TimeIllustration from '../../../assets/time-illustration.png'
import { PaymentEventDto } from '../../../../generated-api'
import Payload from 'components/Payload/Payload'

const EventsTab = (props: { events: PaymentEventDto[] | undefined; loading: boolean; error: unknown }) => {
    const [selectedEvent, setSelectedEvent] = useState<PaymentEventDto>()

    return (
        <div className="flex flex-col desktop:flex-row rounded-lg rounded-tl-none bg-brand-white shadow-lg py-4">
            {props.loading ? (
                <div className="text-center flex my-6 mx-auto">
                    <LoadingWand className="mx-auto" />
                </div>
            ) : props.events?.length ? (
                <>
                    <section className="flex-1 desktop:w-6/12 desktop:order-last border-b-2 desktop:border-0 border-brand-primary desktop:border-grey-lightest pb-3 desktop:pb-0">
                        {selectedEvent ? (
                            <Payload event={selectedEvent} />
                        ) : (
                            <div className="h-full flex flex-col items-center justify-center">
                                <img width={180} height={180} src={TimeIllustration} alt="" />
                                <p className="small text-grey-dark">Select event for payload</p>
                            </div>
                        )}
                    </section>
                    <section className="flex-1 desktop:border-r border-grey-lightest desktop:w-6/12 pt-3 desktop:pt-0 overflow-x-auto">
                        <div className="min-w-full">
                            <table className="text-left overflow-hidden w-full">
                                <thead className="text-grey-dark">
                                    <tr>
                                        <th scope="col" className="font-normal py-2 pl-6">
                                            Event code
                                        </th>
                                        <th scope="col" className="font-normal py-2 px-2">
                                            New state
                                        </th>
                                        <th scope="col" className="font-normal py-2 pr-2">
                                            Created
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.events.map((event, idx) => (
                                        <tr
                                            onClick={() => setSelectedEvent(event)}
                                            key={idx}
                                            className={`hover:bg-purple-lightest cursor-pointer border-t border-grey-lightest ${
                                                event === selectedEvent && 'bg-purple-lightest'
                                            }`}
                                        >
                                            <th
                                                scope="row"
                                                className="text-brand-primary py-4 pl-6 whitespace-nowrap text-sm"
                                            >
                                                {event.eventCode}
                                            </th>
                                            <td className="py-4 whitespace-nowrap text-sm px-2">{event.newState}</td>
                                            <td className="py-4 whitespace-nowrap text-sm pr-2">
                                                {formatDateAndTime(event.created?.toString() ?? '')}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>
                </>
            ) : (
                <Banner kind="warn" stretch="parent" onClose={() => null}>
                    <>{props.error !== null || 'No payment events found'}</>
                </Banner>
            )}
        </div>
    )
}

export default EventsTab
